// @flow

const t0 = "18px";
const t1 = "16px";
const t2 = "14px";
const t3 = "12px";
const t4 = "10px";

export { t0, t1, t2, t3, t4 };
